<template>
  <div class="financial-manage-page" v-if="$route.matched.length === 3">
    <div class="cardList">
      <div class="cardItem">
        <a-row :gutter="16">
          <a-col :span="24">
            <div class="card-item">
              <div class="icon">
                <img src="../../../assets/one.png" />
              </div>
              <div class="card-right">
                <div class="tips">总充值金额</div>
                <div class="money">
                  {{ totalFinancials.totalRechargeAmount || 0 }}<span>元</span>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="cardItem">
        <a-row :gutter="16">
          <a-col :span="8">
            <div class="card-item">
              <div class="icon two">
                <img src="../../../assets/two.png" />
              </div>
              <div class="card-right">
                <div class="tips">总扣费金额</div>
                <div class="money one">
                  {{ totalFinancials.totalUseNumberAmount || 0 }}
                  <span>元</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="card-item">
              <div class="icon one">
                <img src="../../../assets/three.png" />
              </div>
              <div class="card-right">
                <div class="tips">总剩余金额</div>
                <div class="money two">
                  {{ totalFinancials.totalBalance || 0 }}
                  <span>元</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="8" style="padding-right: 0px">
            <div class="card-item">
              <div class="icon three">
                <img src="../../../assets/four.png" />
              </div>
              <div class="card-right">
                <div class="tips">总退款金额</div>
                <div class="money three">
                  {{ totalFinancials.totalQuitNumberAmount || 0 }}
                  <span>元</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="24" style="padding-right: 0px">
            <div class="month">
              <div class="tips">本月金额</div>
              <a-divider type="vertical" />
              <div class="moth-right">
                <div class="tip-money">
                  <div>本月充值金额</div>
                  <div>
                    {{ totalFinancials.monthTotalRechargeAmount || 0
                    }}<span>元</span>
                  </div>
                </div>
                <div class="tip-money">
                  <div>本月扣费金额</div>
                  <div class="two">
                    {{ totalFinancials.monthUseNumberAmount || 0 }}
                    <span>元</span>
                  </div>
                </div>
                <div class="tip-money">
                  <div>本月退款金额</div>
                  <div class="three">
                    {{ totalFinancials.monthQuitNumberAmount || 0 }}
                    <span>元</span>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="tabs">
      <a-tabs :activeKey="activeKey" @change="changeTab">
        <a-tab-pane key="1" tab="充值"> </a-tab-pane>
        <a-tab-pane key="2" tab="扣费"> </a-tab-pane>
        <a-tab-pane key="3" tab="退款"> </a-tab-pane>
      </a-tabs>
    </div>

    <div class="content" id="table">
      <div class="pane-content" v-if="activeKey === '1'">
        <!-- <div class="search-box"> -->
        <a-form :form="rechargeSearchForm" layout="inline">
          <a-form-item label="流水号">
            <a-input placeholder="请输入流水号" v-decorator="['orderNo']" />
          </a-form-item>
          <a-form-item label="租户名称">
            <a-input placeholder="请输入租户名称" v-decorator="['tenatName']" />
          </a-form-item>
          <a-form-item label="充值类型">
            <a-select
              style="width: 165px"
              placeholder="请选择充值类型"
              v-decorator="['rechargeType']"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="ONLINE">线上充值</a-select-option>
              <a-select-option value="MANUAL">手工调账</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="充值状态">
            <a-select
              placeholder="请选择充值状态"
              style="width: 165px"
              v-decorator="['flowStatus']"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="SUCCESS">成功</a-select-option>
              <a-select-option value="WAIT">待审核</a-select-option>
              <a-select-option value="REJECT">驳回</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="充值时间">
            <a-range-picker v-decorator="['time']" />
          </a-form-item>
        </a-form>
        <div class="btn-group">
          <a-button type="primary" @click="onSearchRecharge">搜索</a-button>
          <a-button
            type="default"
            style="margin-left: 20px"
            @click="rechargeSearchForm.resetFields()"
            >重置</a-button
          >

          <a-button
            type="primary"
            style="margin-left: 20px"
            @click="openRechargeModal"
            >充值</a-button
          >
          <a-button
            type="primary"
            style="margin-left: 20px"
            @click="onExport('recharge')"
            >导出Excel</a-button
          >
        </div>
        <!-- </div> -->
        <div class="total-table">
          <a-table
            rowKey="id"
            :scroll="{ x: 1100 }"
            :columns="rechargeColumns"
            :dataSource="rechargeDataSource"
            :pagination="rechargePagi"
            @change="(pagination) => getRechargeData(pagination.current - 1)"
          >
            <template slot="status" slot-scope="text, record">
              <div
                style="display: flex; align-items: center"
                v-if="text === 'WAIT' || text === 'SUCCESS'"
              >
                <i
                  style="color: #22dd90; margin-right: 8px"
                  class="iconfont icon-dian"
                />
                <div>{{ text === "WAIT" ? "等待中" : "审核成功" }}</div>
              </div>
              <a-tooltip>
                <template slot="title">
                  <div class="tooltip-content">
                    <div class="label">
                      驳回原因：{{ record.rejectReason || "暂无" }}
                    </div>
                  </div>
                </template>
                <div
                  style="display: flex; align-items: center"
                  v-if="text === 'REJECT'"
                >
                  <i
                    style="color: #dd6d22; margin-right: 8px"
                    class="iconfont icon-dian"
                  />
                  <div>驳回</div>
                </div>
              </a-tooltip>
              <div v-if="!text">--</div>
            </template>
            <template slot="operation" slot-scope="record">
              <div class="handle">
                <a-tooltip title="查看凭证">
                  <div class="icon" @click="onOpenViewModal(record)">
                    <i class="iconfont icon-chakan" />
                  </div>
                </a-tooltip>
                <a-tooltip title="上传凭证">
                  <div
                    :class="{
                      icon: true,
                      disabled: record.flowStatus !== 'WAIT',
                    }"
                    @click="againUpload(record)"
                  >
                    <i class="iconfont icon-daoru" />
                  </div>
                </a-tooltip>
              </div>
            </template>
            <template slot="remark" slot-scope="text">
              <a-tooltip>
                <template slot="title">
                  {{ text }}
                </template>
                <div>{{ text }}</div>
              </a-tooltip>
            </template>
          </a-table>
        </div>
      </div>

      <div class="pane-content" v-if="activeKey === '2'">
        <a-form :form="deductionSearchForm" layout="inline">
          <a-form-item label="流水号">
            <a-input placeholder="请输入流水号" v-decorator="['orderNo']" />
          </a-form-item>
          <a-form-item label="租户名称">
            <a-input placeholder="请输入租户名称" v-decorator="['tenatName']" />
          </a-form-item>
          <a-form-item label="合同编号">
            <a-input placeholder="请输入合同编号" v-decorator="['contactNo']" />
          </a-form-item>
          <a-form-item label="创建时间">
            <a-range-picker v-decorator="['time']" />
          </a-form-item>
          <a-form-item label="结算周期">
            <a-range-picker v-decorator="['preTime']" />
          </a-form-item>
        </a-form>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 16px;
          "
        >
          <a-button type="primary" @click="onDeductionSearch">搜索</a-button>
          <a-button
            type="default"
            style="margin-left: 20px"
            @click="deductionSearchForm.resetFields()"
            >重置</a-button
          >

          <a-button
            type="primary"
            style="margin-left: 20px"
            @click="onExport('deduction')"
            >导出Excel</a-button
          >
        </div>
        <div class="total-table">
          <!-- <div class="total">
            <div class="btn-list">
              <a-button type="primary" @click="onExport('deduction')"
                >导出Excel</a-button
              >
            </div>
          </div> -->
          <a-table
            rowKey="id"
            :scroll="{ x: 1100 }"
            :columns="deductionColumns"
            :dataSource="deductionDataSource"
            :pagination="deductionPagi"
          >
            <template slot="operation" slot-scope="record">
              <div class="handle">
                <a-tooltip title="查看明细">
                  <div class="icon" @click="goDetail(record)">
                    <i class="iconfont icon-chakan" />
                  </div>
                </a-tooltip>
                <!-- <a-tag color="blue" @click="goDetail(record)"
                  >查看明细</a-tag
                > -->
              </div>
            </template>
          </a-table>
        </div>
      </div>

      <div class="pane-content" v-if="activeKey === '3'">
        <a-form :form="refundSearchForm" layout="inline">
          <a-form-item label="流水号">
            <a-input placeholder="请输入流水号" v-decorator="['orderNo']" />
          </a-form-item>
          <a-form-item label="租户名称">
            <a-input placeholder="请输入租户名称" v-decorator="['tenatName']" />
          </a-form-item>
          <a-form-item label="合同编号">
            <a-input placeholder="请输入合同编号" v-decorator="['contactNo']" />
          </a-form-item>
          <a-form-item label="退款时间">
            <a-range-picker v-decorator="['time']" />
          </a-form-item>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin-top: 16px;
            "
          >
            <a-button type="primary" @click="onRefundSearch">搜索</a-button>
            <a-button
              type="default"
              style="margin-left: 20px"
              @click="refundSearchForm.resetFields()"
              >重置</a-button
            >
            <a-button
              style="margin-left: 20px"
              type="primary"
              @click="onExport('quit')"
              >导出Excel</a-button
            >
          </div>
        </a-form>
        <div class="total-table">
          <!-- <div class="total">
            <div class="money">
              退款总金额：{{ quitNumberAmount || 0 }}元
            </div>
            <div class="btn-list">
              <a-button type="primary" @click="onExport('quit')"
                >导出Excel</a-button
              >
            </div>
          </div> -->
          <a-table
            rowKey="id"
            :scroll="{ x: 1100 }"
            :columns="refundColumns"
            :dataSource="refundDataSource"
            :pagination="refundPagi"
          >
            <template slot="refundRemark" slot-scope="text">
              <a-tooltip>
                <template slot="title">
                  {{ text }}
                </template>
                <div>{{ text }}</div>
              </a-tooltip>
            </template>
          </a-table>
        </div>
      </div>
    </div>

    <a-modal
      title="充值"
      width="400px"
      :visible="rechargeVisible"
      :maskClosable="false"
      @cancel="handleClose"
    >
      <template slot="footer">
        <div class="btn-list">
          <a-button @click="handleClose">取消</a-button>
          <a-button type="primary" v-if="step === 1" @click="handleSave"
            >保存</a-button
          >
          <a-button type="primary" v-if="step === 2" @click="onSub"
            >确定</a-button
          >
        </div>
      </template>

      <a-form
        :form="form"
        :labelCol="{ span: 6, offset: 3 }"
        :wrapperCol="{ span: 12 }"
      >
        <a-form-item label="租户名称" v-if="step === 1">
          <a-select
            v-decorator="[
              'tenatId',
              { rules: [{ required: true, message: '请选择租户名称' }] },
            ]"
            placeholder="请选择租户名称"
            :showSearch="true"
            @search="getTenantData"
          >
            <a-select-option
              v-for="item in tenantList"
              :key="item.id"
              :value="item.id"
              >{{ item.tenatName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="充值类型" v-if="step === 1">
          <a-select
            v-decorator="[
              'rechargeType',
              { rules: [{ required: true, message: '请选择充值类型' }] },
            ]"
            placeholder="请选择充值类型"
          >
            <a-select-option value="ONLINE">线上充值</a-select-option>
            <a-select-option value="MANUAL">手工调账</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="充值金额" v-if="step === 1">
          <a-input-number
            v-decorator="[
              'rechargeNumber',
              { rules: [{ required: true, message: '请输入充值金额' }] },
            ]"
            placeholder="请输入充值金额"
          />
        </a-form-item>
        <a-form-item label="备注" v-if="step === 1">
          <a-input
            autoComplete="off"
            placeholder="请输入备注"
            v-decorator="['remark']"
          />
        </a-form-item>
        <a-form-item
          v-if="step === 2"
          label="充值凭证"
          extra="上传充值凭证，最多可上传5张"
          :labelCol="{ span: 6 }"
          :wrapperCol="{ span: 18 }"
        >
          <a-upload
            v-decorator="['avatar']"
            list-type="picture-card"
            class="avatar-uploader"
            :file-list="fileList"
            :customRequest="uploadSuccess"
            :remove="removeUpload"
          >
            <div v-if="fileList.length < 5">
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">图片上传</div>
            </div>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      class="view-modal"
      title="充值凭证"
      :visible="viewVisible"
      :maskClosable="false"
      :footer="null"
      @cancel="handleCloseView"
    >
      <a-upload
        v-if="fileList.length > 0"
        list-type="picture-card"
        class="avatar-uploader"
        :showUploadList="{
          showRemoveIcon: false,
        }"
        :file-list="fileList"
      >
      </a-upload>
      <div v-else class="no-file">暂无充值凭证</div>
    </a-modal>
  </div>
  <router-view v-else></router-view>
</template>
<script>
import moment from "moment";
import eventStatusMixin from "../../../mixins/eventStatus";
import {
  contractBillPage,
  contractWalletQuitPage,
  contractWalletRechargeAdd,
  contractWalletRechargePage,
  financeManageStatistics,
  tenantPage,
  fileInfoRemove,
  fileListResource,
} from "./service";
import { domainStr } from "../../../utils/request";
import scrollbarInit from "../../../utils/perfectScrollBar";
import axios from "axios";

const rechargeColumns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 100,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "流水号",
    dataIndex: "orderNo",
    width: 150,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "租户名称",
    dataIndex: "tenatName",
    width: 150,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "充值类型",
    dataIndex: "rechargeType",
    width: 100,
    customRender: (text) => {
      const stu = {
        ONLINE: "线上充值",
        MANUAL: "手工调账",
      };
      return stu[text] || "--";
    },
  },
  {
    title: "充值状态",
    dataIndex: "flowStatus",
    // customRender: (text) => {
    //   const stu = {
    //     WAIT: "待审核",
    //     SUCCESS: "审核成功",
    //     REJECT: "驳回",
    //   };
    //   return stu[text] || "--";
    // },
    width: 100,
    scopedSlots: {
      customRender: "status",
    },
  },
  // {
  //   title: "驳回原因",
  //   dataIndex: "rejectReason",
  //   width:150,
  //   customRender: (text) => {
  //     return text || "--";
  //   },
  // },
  {
    title: "充值时间",
    dataIndex: "dateCreated",
    width: 150,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "充值金额",
    dataIndex: "rechargeNumber",
    width: 100,
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "备注",
    dataIndex: "remark",
    width: 150,
    ellipsis: true,
    customRender: (text) => {
      return text || "--";
    },
    scopedSlots: { customRender: "remark" },
  },
  {
    title: "充值前余额",
    dataIndex: "preNumber",
    width: 100,
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "充值后余额",
    width: 100,
    dataIndex: "afterNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "操作",
    dataIndex: "",
    width: 150,
    scopedSlots: { customRender: "operation" },
  },
];
const deductionColumns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 100,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "流水号",
    dataIndex: "orderNo",
    width: 200,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "合同编号",
    width: 200,
    dataIndex: "contactNo",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "租户名称",
    width: 150,
    dataIndex: "tenatName",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "联系方式",
    width: 150,
    dataIndex: "contactPhone",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "扣费金额",
    width: 100,
    dataIndex: "useNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "扣费前余额",
    width: 120,
    dataIndex: "preNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "扣费后余额",
    width: 120,
    dataIndex: "afterNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "创建时间",
    width: 200,
    dataIndex: "dateCreated",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "结算开始时间",
    width: 200,
    dataIndex: "preDate",
    customRender: (text) => {
      return `${moment(text).format("YYYY-MM-DD") || "--"}`;
    },
  },
  {
    title: "结算结束时间",
    width: 200,
    dataIndex: "endDate",
    customRender: (text) => {
      return `${moment(text).format("YYYY-MM-DD") || "--"}`;
    },
  },
  {
    title: "操作",
    dataIndex: "",
    width: 100,
    scopedSlots: { customRender: "operation" },
  },
];

const refundColumns = [
  {
    title: "序号",
    dataIndex: "index",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "流水号",
    dataIndex: "orderNo",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "合同编号",
    dataIndex: "contactNo",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "租户名称",
    dataIndex: "tenatName",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "联系方式",
    dataIndex: "contactPhone",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "退款金额",
    dataIndex: "quitNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "退款时间",
    dataIndex: "dateCreated",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "备注",
    dataIndex: "remark",
    customRender: (text) => {
      return text || "--";
    },
    scopedSlots: { customRender: "refundRemark" },
    ellipsis: true,
  },
];
export default {
  mixins: [eventStatusMixin],
  data() {
    return {
      rechargeSearchForm: this.$form.createForm(this),
      deductionSearchForm: this.$form.createForm(this),
      refundSearchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      activeKey: "1",
      totalFinancials: {},

      rechargeColumns,
      rechargeDataSource: [],
      rechargePagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      totalRecharge: 0,
      tenantList: [],

      deductionColumns,
      deductionDataSource: [],
      deductionPagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      useNumberAmount: 0,

      refundColumns,
      refundDataSource: [],
      refundPagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      quitNumberAmount: 0,

      rechargeVisible: false,

      searchParams: {},

      loading: false,
      step: 1,
      domainStr,
      fileList: [],

      viewVisible: false,
      modalRecord: {},
    };
  },
  created() {
    this.getRechargeData();
    this.getAllTotalData();
  },
  mounted() {
    this.createScroll();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.createScroll();
      });
    },
  },
  methods: {
    againUpload(record) {
      this.modalRecord = record;
      this.rechargeVisible = true;
      this.step = 2;
      this.getContractImg(record.id);
    },
    onOpenViewModal(record) {
      this.viewVisible = true;
      this.getContractImg(record.id);
    },
    handleCloseView() {
      this.viewVisible = false;
      this.fileList = [];
    },
    async getContractImg(id) {
      try {
        const params = {
          resourceId: id,
          resourceType: "rechargeFlow",
        };

        const res = await fileListResource.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          let fileList = [];
          res.data.map((item) => {
            fileList.push({
              uid: item.id,
              name: "image.png",
              status: "done",
              url: item.url,
            });
          });
          this.fileList = fileList;
        }
      } catch (err) {
        console.error(err);
      }
    },
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    async removeUpload(file) {
      console.log(file);
      try {
        const params = {
          id: file.uid,
        };

        const res = await fileInfoRemove.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          let list = [];
          this.fileList.map((item) => {
            if (item.uid !== file.uid) {
              list.push({ ...item });
            }
          });
          this.fileList = list;
        } else {
          return false;
        }
      } catch (err) {
        console.error(err);
      }
      return false;
    },
    uploadSuccess(options) {
      const { file } = options;

      let params = new FormData();
      params.append("file", file);
      params.append("id", this.modalRecord.id);
      let url = `${domainStr}/v2/contract/wallet/img/upload`;
      this.loading = true;
      axios
        .post(url, params, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then((response) => {
          const res = response.data;
          this.loading = false;
          if (res.bizCode === 1) {
            let fileList = this.fileList;
            fileList.push({
              uid: res.data.id,
              name: "image.png",
              status: "done",
              url: res.data.destFileName,
            });
            this.fileList = fileList;
          } else {
            this.$message.info("上传失败，请重新上传");
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("仅支持JPG文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片必须小于2MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    onSub() {
      this.step = 2;
      this.handleClose();
    },
    changeTab(key) {
      this.rechargeSearchForm.resetFields();
      this.deductionSearchForm.resetFields();
      this.refundSearchForm.resetFields();
      this.searchParams = {};
      this.activeKey = key;
      this.setState();
      if (key === "1") {
        this.getRechargeData();
      } else if (key === "2") {
        this.getDeductionData();
      } else if (key === "3") {
        this.getRefundData();
      }
    },
    setState() {
      this.rechargeDataSource = [];
      this.rechargePagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.totalRecharge = 0;

      this.deductionDataSource = [];
      this.deductionPagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.useNumberAmount = 0;

      this.refundDataSource = [];
      this.refundPagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.quitNumberAmount = 0;
    },
    openRechargeModal() {
      this.getTenantData();
      this.rechargeVisible = true;
    },
    handleClose() {
      this.rechargeVisible = false;
      this.form.resetFields();
      this.tenantList = [];
      this.step = 1;
      this.modalRecord = {};
    },
    goDetail(record) {
      console.log(record);
      let deductions = JSON.stringify(record);
      this.$router.push({
        path: "/app/signing/financialmanage/detail",
        query: {
          deductions,
        },
      });
    },
    async getRechargeData(pageNo = 0) {
      try {
        const params = Object.assign(
          {
            pageNo,
            pageSize: 10,
          },
          this.searchParams
        );

        const res = await contractWalletRechargePage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = [];
          res.data.pageData.items.map((item, index) => {
            data.push({ ...item, index: index + 1 });
          });
          const pagination = {
            current: res.data.pageData.pageNo + 1,
            pageSize: 10,
            total: res.data.pageData.totalCount,
          };
          //console.log(data)
          this.totalRecharge = res.data.totalRechargeAmount || 0;
          this.rechargeDataSource = data;
          this.rechargePagi = pagination;
        }
      } catch (err) {
        console.error(err);
      }
    },
    onSearchRecharge() {
      const data = this.rechargeSearchForm.getFieldsValue();
      const searchParams = {};
      Object.keys(data).map((key) => {
        if (key === "time" && data[key] && data[key].length > 1) {
          searchParams.timeFrom = moment(data[key][0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          searchParams.timeTo = moment(data[key][1]).format(
            "YYYY-MM-DD 23:59:59"
          );
        } else {
          data[key] && (searchParams[key] = data[key]);
        }
      });
      this.searchParams = searchParams;
      this.getRechargeData();
    },
    async getTenantData(val) {
      try {
        const params = {
          isPage: 0,
          tenatName: val,
        };
        const res = await tenantPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          console.log(res);
          this.tenantList = res.data.items;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async handleSave() {
      if (this.hasEventState("handleSave")) return;
      try {
        this.addEventState("handleSave");
        const formVal = await this.form.validateFields();
        const params = {
          ...formVal,
        };

        const res = await contractWalletRechargeAdd.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          // this.$message.success("充值成功，等待审核");
          this.$message.success(`充值成功，请上传充值凭证`);
          this.modalRecord = {
            id: res.data,
          };
          this.step = 2;
          // this.handleClose();
          this.getRechargeData(this.rechargePagi.current - 1);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("handleSave");
      }
    },
    async getDeductionData(pageNo = 0) {
      try {
        const params = Object.assign(
          {
            pageNo,
            pageSize: 10,
          },
          this.searchParams
        );

        const res = await contractBillPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = [];
          res.data.pageData.items.map((item, index) => {
            data.push({ ...item, index: index + 1 });
          });
          const pagination = {
            current: res.data.pageData.pageNo + 1,
            pageSize: 10,
            total: res.data.pageData.totalCount,
          };
          //console.log(data)
          this.useNumberAmount = res.data.useNumberAmount || 0;
          this.deductionDataSource = data;
          this.deductionPagi = pagination;
        }
      } catch (err) {
        console.error(err);
      }
    },
    onDeductionSearch() {
      const data = this.deductionSearchForm.getFieldsValue();
      const searchParams = {};
      Object.keys(data).map((key) => {
        if (key === "time" && data[key] && data[key].length > 1) {
          searchParams.timeFrom = moment(data[key][0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          searchParams.timeTo = moment(data[key][1]).format(
            "YYYY-MM-DD 23:59:59"
          );
        } else if (key === "preTime" && data[key] && data[key].length > 1) {
          searchParams.preDate = moment(data[key][0]).format("YYYY-MM-DD");
          searchParams.endDate = moment(data[key][1]).format("YYYY-MM-DD");
        } else {
          data[key] && (searchParams[key] = data[key]);
        }
      });
      this.searchParams = searchParams;
      this.getDeductionData();
    },
    async getRefundData(pageNo = 0) {
      try {
        const params = Object.assign(
          {
            pageNo,
            pageSize: 10,
          },
          this.searchParams
        );

        const res = await contractWalletQuitPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = [];
          res.data.pageData.items.map((item, index) => {
            data.push({ ...item, index: index + 1 });
          });
          const pagination = {
            current: res.data.pageData.pageNo + 1,
            pageSize: 10,
            total: res.data.pageData.totalCount,
          };
          //console.log(data)
          this.quitNumberAmount = res.data.quitNumberAmount || 0;
          this.refundDataSource = data;
          this.refundPagi = pagination;
        }
      } catch (err) {
        console.error(err);
      }
    },
    onRefundSearch() {
      const data = this.refundSearchForm.getFieldsValue();
      const searchParams = {};
      Object.keys(data).map((key) => {
        if (key === "time" && data[key] && data[key].length > 1) {
          searchParams.timeFrom = moment(data[key][0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          searchParams.timeTo = moment(data[key][1]).format(
            "YYYY-MM-DD 23:59:59"
          );
        } else {
          data[key] && (searchParams[key] = data[key]);
        }
      });
      this.searchParams = searchParams;
      this.getRefundData();
    },
    async getAllTotalData() {
      try {
        const params = {};
        const res = await financeManageStatistics.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.totalFinancials = res.data;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onExport(type) {
      try {
        const apiUrl = {
          recharge: "/v2/contract/wallet/recharge/flow/review/export",
          quit: "/v2/contract/wallet/quit/flow/export",
          deduction: "/v2/contract/bill/deduction/export",
        };
        let url = `${domainStr}${apiUrl[type]}`;
        let searchParams = this.searchParams;
        if (Object.keys(searchParams).length > 0) {
          url = url + "?";
          Object.keys(searchParams).map((key) => {
            if (searchParams[key]) {
              url = url + key + "=" + searchParams[key] + "&";
            }
          });
        }

        console.log(url);

        const downName = {
          recharge: "充值记录.xlsx",
          quit: "退款记录.xlsx",
          deduction: "扣费记录.xlsx",
        };

        const a = document.createElement("a");
        a.href = url;
        a.download = downName[type];
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.financial-manage-page {
  width: 100%;
  overflow: hidden;
  > .cardList {
    width: 100%;
    height: .convertPxToDesighVH(193) [];
    display: flex;
    flex-direction: row;
    > .cardItem:first-of-type {
      width: 25%;
      min-height: .convertPxToDesighVH(193) [];
      > .ant-row {
        width: 100%;
        min-height: .convertPxToDesighVH(193) [];
        > .ant-col {
          min-height: .convertPxToDesighVH(193) [];
          > .card-item {
            min-height: .convertPxToDesighVH(193) [];
            background: #192430;
            border: .convertPxToDesighVH(2) [] solid #293646;
            border-radius: .convertPxToDesighVH(10) [];
            padding-left: .convertPxToDesighVW(23) [];
            padding-right: .convertPxToDesighVW(23) [];
            display: flex;
            flex-direction: row;
            align-items: center;

            > .icon {
              margin-top: .convertPxToDesighVH(10) [];
              width: .convertPxToDesighVW(96) [];
              height: .convertPxToDesighVH(96) [];
              background: rgba(24, 144, 255, 0.1);
              border-radius: .convertPxToDesighVH(10) [];
              margin-bottom: .convertPxToDesighVH(16) [];
              img {
                width: .convertPxToDesighVW(96) [];
                height: .convertPxToDesighVH(96) [];
              }
            }
            > .card-right {
              font-size: .convertPxToDesighVH(40) [];
              font-family: Microsoft YaHei;
              font-weight: bold;
              display: flex;
              flex-direction: column;
              color: #00c977;
              span {
                font-size: .convertPxToDesighVH(14) [];
                font-family: Microsoft YaHei;
                font-weight: 300;
                line-height: .convertPxToDesighVH(20) [];
                color: #909ca6;
              }
              > .tips {
                margin-left: .convertPxToDesighVW(16) [];
                font-size: .convertPxToDesighVH(16) [];
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #e2f2ff;
              }
              .money {
                margin-left: .convertPxToDesighVW(16) [];
              }
            }
          }
        }
      }
    }
    > .cardItem:last-of-type {
      width: 75%;
      height: 100%;
      > .ant-row {
        width: 100%;
        min-height: .convertPxToDesighVH(193) [];
        > .ant-col {
          height: .convertPxToDesighVH(88) [];
          > .card-item {
            height: 100%;
            background: #192430;
            border: .convertPxToDesighVH(2) [] solid #293646;
            border-radius: .convertPxToDesighVH(10) [];
            padding: .convertPxToDesighVH(23) [];
            display: flex;
            align-items: center;
            > .icon {
              width: .convertPxToDesighVW(48) [];
              height: .convertPxToDesighVH(48) [];
              border-radius: .convertPxToDesighVH(10) [];
              img {
                width: .convertPxToDesighVW(48) [];
                height: .convertPxToDesighVH(48) [];
              }
            }
            > .card-right {
              display: flex;
              flex-direction: column;
              margin-top: 0 !important;
              > .tips {
                font-size: .convertPxToDesighVH(16) [];
                font-family: Microsoft YaHei;
                font-weight: 300;
                color: #909ca6;
                margin-left: .convertPxToDesighVW(16) [];
              }
              > .icon {
                width: .convertPxToDesighVW(48) [];
                height: .convertPxToDesighVH(48) [];
                // background: rgba(255, 68, 30, 0.1);
                //background: #ff441e;
                // opacity: 0.1;
                border-radius: .convertPxToDesighVH(10) [];
                img {
                  width: .convertPxToDesighVW(48) [];
                  height: .convertPxToDesighVH(48) [];
                }
              }
              > .icon.two {
                background: rgba(25, 197, 97, 0.1);
              }
              > .icon.three {
                background: rgba(254, 157, 0, 0.1);
                //background: #fe9d00;
              }
              margin-top: .convertPxToDesighVH(15) [];
              > .money {
                margin-left: .convertPxToDesighVW(16) [];
                font-size: .convertPxToDesighVH(24) [];
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #0090ff;
                span {
                  font-size: .convertPxToDesighVH(14) [];
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #909ca6;
                }
              }
              > .money.two {
                color: #fe9d00;
                span {
                  font-size: .convertPxToDesighVH(14) [];
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #909ca6;
                }
              }
              > .money.three {
                color: #dd6d22;
                span {
                  font-size: .convertPxToDesighVH(14) [];
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #909ca6;
                }
              }
            }
          }
        }
        > .ant-col:last-of-type {
          margin-top: .convertPxToDesighVH(20) [];
          > .month {
            width: 100%;
            display: flex;
            align-items: center;
            border-radius: .convertPxToDesighVH(10) [];
            height: .convertPxToDesighVH(88) [];
            background: #192430;
            border: .convertPxToDesighVH(2) [] solid #293646;
            padding: 0px .convertPxToDesighVW(20) [];
            > .tips {
              font-size: .convertPxToDesighVH(16) [];
              font-family: Microsoft YaHei;
              font-weight: bold;

              color: #e2f2ff;
            }
            > .ant-divider {
              margin-left: .convertPxToDesighVW(45) [];
              height: .convertPxToDesighVH(40) [];
            }
            > .moth-right {
              margin-left: .convertPxToDesighVW(45) [];
              width: calc(100% - .convertPxToDesighVW(200) []);
              display: flex;
              align-items: center;
              justify-content: space-between;
              > .tip-money {
                span {
                  font-size: .convertPxToDesighVH(14) [];
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #909ca6;
                }
                > div:first-of-type {
                  font-size: .convertPxToDesighVH(14) [];
                  font-family: Microsoft YaHei;
                  font-weight: 300;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #909ca6;
                  margin-bottom: .convertPxToDesighVH(18) [];
                }
                > div:last-of-type {
                  font-size: .convertPxToDesighVH(24) [];
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  line-height: .convertPxToDesighVH(20) [];
                  color: #00c977;
                }
                > div.two {
                  color: #fe9d00;
                  span {
                    font-size: .convertPxToDesighVH(14) [];
                    font-family: Microsoft YaHei;
                    font-weight: 300;
                    line-height: .convertPxToDesighVH(20) [];
                    color: #909ca6;
                  }
                }
                > div.three {
                  color: #dd6d22;
                  span {
                    font-size: .convertPxToDesighVH(14) [];
                    font-family: Microsoft YaHei;
                    font-weight: 300;
                    line-height: .convertPxToDesighVH(20) [];
                    color: #909ca6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  > .tabs {
    margin-top: .convertPxToDesighVH(20) [];
    padding-left: .convertPxToDesighVW(20) [];
    padding-right: .convertPxToDesighVW(20) [];
    width: 100%;
    background: #192430;
    height: .convertPxToDesighVH(72) [];
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    > .ant-tabs {
      width: 100%;
    }
  }
  .content {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    margin-top: .convertPxToDesighVH(20) [];
    padding: .convertPxToDesighVH(24) [];
    height: calc(100vh - .convertPxToDesighVH(426) []);
    // overflow: auto;
    > .pane-content {
      > .btn-group {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: .convertPxToDesighVH(16) [];
      }
      > .total-table {
        margin-top: .convertPxToDesighVH(20) [];
        > .total {
          padding: .convertPxToDesighVH(10) [];
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: .convertPxToDesighVH(20) [];
          background: transparent;
          border-radius: .convertPxToDesighVH(5) [];
          > .money {
            font-size: .convertPxToDesighVH(14) [];
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: .convertPxToDesighVH(24) [];
            color: #e2f2ff;
          }
        }
        > .ant-table-wrapper {
          .handle {
            display: flex;
            .icon {
              width: .convertPxToDesighVW(40) [];
              height: .convertPxToDesighVH(40) [];
              background: #091121;
              border-radius: .convertPxToDesighVH(15) [];
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: .convertPxToDesighVW(24) [];
            }
            .disabled {
              cursor: not-allowed;
              opacity: 0.5;
            }
            > .ant-tag {
              height: .convertPxToDesighVH(30) []30px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: .convertPxToDesighVH(14) [];
              font-family: Microsoft YaHei;
              font-weight: 300;
              margin-right: .convertPxToDesighVW(20) [];
            }
          }
        }
      }
    }
  }
}

.view-modal {
  .ant-modal-body {
    > .no-file {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: .convertPxToDesighVH(24) [];
      color: #a5b8b4;
    }
  }
}

#table {
  position: relative;
  overflow: hidden;
}
</style>
